import { render, staticRenderFns } from "./PopupFiltersTeam.vue?vue&type=template&id=39991f32"
import script from "./PopupFiltersTeam.vue?vue&type=script&lang=ts"
export * from "./PopupFiltersTeam.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports